export enum BlobEntityType {
    IntakePet = "IntakePet",
    Pet = "Pet",
    SalesItem = "SalesItem",
    Signatures = "Signatures",
    License = "License",
    AssessmentReferral = "AssessmentReferral",
    Attachment = "Attachment",
    Question = "Question",
}
